import {
  faCircleExclamation,
  faCheck,
  faTriangleExclamation,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { NotificationData, notifications } from "@mantine/notifications";

export const showSuccessNotification = (notification: NotificationData) => {
  notifications.show({
    autoClose: 8000,
    ...notification,
    color: "teal",
    icon: <FontAwesomeIcon icon={faCheck} />,
  });
};

export const showErrorNotification = (notification: NotificationData) => {
  notifications.show({
    autoClose: 8000,
    ...notification,
    color: "red",
    icon: <FontAwesomeIcon icon={faCircleExclamation} />,
  });
};

export const showWarningNotification = (notification: NotificationData) => {
  notifications.show({
    autoClose: 8000,
    ...notification,
    color: "orange",
    icon: <FontAwesomeIcon icon={faTriangleExclamation} />,
  });
};
